import React, {useState,useContext} from 'react'
import {dataContext,localestr,uid} from '../utils.js'
import EditCtrl from '../cmp/EditCtrl.js';


export default function FldModifiers({data,action}){
    const context=useContext(dataContext)
    const close_msg=context.clsTWnd
    const msg=context.msg
    const [tmpData, setTmpData] = useState(data||{})
    const setValue=(name,data)=>{
        const newData={uid:uid(),type:0,...tmpData}
        newData[name]=data
        newData.edit=true
        setTmpData(newData)
    }

    const saveValue=()=>{
        if(!tmpData.name){
            msg(localestr('Необхідно заповнити назву!'),localestr('Помилка'),[{caption:'OK',action:()=>{}}])
            return
        }
        tmpData.name=tmpData.name.substring(0, 50)
        action(tmpData)
        close_msg()
    }

    return(

        <div style={{display:'flex',flexDirection:'column', margin:'4px 0',minWidth:'337px',maxWidth:'640px'}}>
        <EditCtrl Capt={localestr('Назва')} Value={tmpData.name||null} typeVal={'text'} setVal={(d)=>{setValue('name',d)}} width1='50' width2='287'/>
        <div style={{margin:'4px 0'}}>{localestr('Можливість вибору кількох модифікаторів')}</div>
        <div style={{margin:'4px 4px'}}><input id='1' type='radio' checked={tmpData.type===1?1:0} onChange={()=>{setValue('type',1)}} /><label htmlFor='1'>{localestr('Тільки один')}</label></div>
        <div style={{margin:'0 0 8px 24px',fontStyle:'italic'}}>{localestr('Можливість вибрати тільки один варіант. (Наприклад: ступінь прожарки)')}</div>
        <div style={{margin:'4px 4px'}}><input id='2' type='radio' checked={tmpData.type===0?1:0} onChange={()=>{setValue('type',0)}} /><label htmlFor='2'>{localestr('Декілька')}</label></div>
        <div style={{margin:'0 0 8px 24px',fontStyle:'italic'}}>{localestr('Можливість вибрати декілька, всі або жодного. (Наприклад: додаткові спеції до м\'яса)')}</div>
        <div className='no-print' style={{margin:'10px 0 0 0',minWidth:'337px',maxWidth:'674px',display:'flex',justifyContent:'center',flexGrow:'100000'}}>
        <div style={{width:'54px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={saveValue}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>OK</div></div>
        </div>
        </div>
        )
}
